import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuitabilityPipe } from './suitability.pipe';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ SuitabilityPipe ],
    exports: [ SuitabilityPipe ],
})
export class SuitabilityPipeModule {}
